import { Card, CardContent } from "@/components/ui/card";
import WhatsAppButton from "@/components/home/WhatsAppButton";
import { Shield, Star, ShieldCheck, Users } from "lucide-react";

export default function About() {
  return (
    <div className="bg-[#fcfcfb]">
      <div className="max-w-[1920px] w-full mx-auto px-3 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-6 sm:py-8 lg:py-12">
        {/* Primeira Seção: Sobre nós */}
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <h1 className="font-['MontserratAlt1'] font-light text-4xl text-center text-[#132034] mb-6 sm:mb-8 lg:mb-12 max-w-5xl mx-auto">
            Sobre a A Bordo Viagens
          </h1>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 max-w-5xl mx-auto">
            <Card className="overflow-hidden lg:max-w-[500px] justify-self-center lg:justify-self-end h-full">
              <CardContent className="p-0 h-full flex items-center justify-center bg-[#132034]">
                <img
                  src="/logotipo.png"
                  alt="Viagem de luxo"
                  className="w-full h-auto max-h-[400px] object-contain py-8"
                />
              </CardContent>
            </Card>

            <div className="flex flex-col justify-center space-y-4 max-w-xl lg:max-w-none mx-auto lg:mx-0">
              <h2 className="font-['MontserratAlt1'] font-light text-xl sm:text-2xl lg:text-3xl text-[#132034]">
                Nossa História
              </h2>
              <div className="space-y-4 text-sm sm:text-base lg:text-lg text-[#132034]">
                <p>
                  Fundada em 2023, a A Bordo Viagens nasceu da experiência adquirida
                  no setor aéreo desde 2020. Somos uma agência online comprometida
                  em proporcionar experiências de viagem excepcionais.
                </p>
                <p>
                  Nosso foco vai além de oferecer passagens aéreas com preços competitivos:
                  auxiliamos em cada etapa da sua jornada para que você possa
                  aproveitar o destino sem preocupações. Cuidamos de detalhes como
                  check-in, transfer e conexões, proporcionando mais comodidade e
                  tranquilidade.
                </p>
                <p>
                  Com uma equipe especializada e profundo conhecimento do setor,
                  garantimos viagens planejadas com segurança, conforto e um
                  atendimento totalmente personalizado para você.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Segunda Seção: Nossos Valores */}
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-['MontserratAlt1'] font-light text-4xl text-center text-[#132034] mb-6 sm:mb-8 lg:mb-12 text-center">
              Nossos Valores
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
              <Card className="group hover:border-[#b3855e] transition-colors duration-300 bg-white shadow-sm">
                <CardContent className="p-5 sm:p-6 lg:p-8">
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-3 mb-3 sm:mb-4">
                      <div className="p-3 rounded-full bg-[#f8f3ef] group-hover:bg-[#b3855e] transition-colors duration-300">
                        <Star className="h-6 w-6 sm:h-7 sm:w-7 text-[#b3855e] group-hover:text-white transition-colors duration-300" />
                      </div>
                      <h3 className="text-base sm:text-lg lg:text-xl text-[#b3855e] font-['MontserratAlt1']">
                        Excelência
                      </h3>
                    </div>
                    <p className="text-sm sm:text-base text-[#132034] text-center">
                      Comprometimento com a qualidade em cada detalhe da sua viagem, garantindo experiências memoráveis.
                    </p>
                  </div>
                </CardContent>
              </Card>
              <Card className="group hover:border-[#b3855e] transition-colors duration-300 bg-white shadow-sm">
                <CardContent className="p-5 sm:p-6 lg:p-8">
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-3 mb-3 sm:mb-4">
                      <div className="p-3 rounded-full bg-[#f8f3ef] group-hover:bg-[#b3855e] transition-colors duration-300">
                        <ShieldCheck className="h-6 w-6 sm:h-7 sm:w-7 text-[#b3855e] group-hover:text-white transition-colors duration-300" />
                      </div>
                      <h3 className="text-base sm:text-lg lg:text-xl text-[#b3855e] font-['MontserratAlt1']">
                        Confiabilidade
                      </h3>
                    </div>
                    <p className="text-sm sm:text-base text-[#132034] text-center">
                      Experiência comprovada no mercado aéreo desde 2022, oferecendo segurança e tranquilidade em cada viagem.
                    </p>
                  </div>
                </CardContent>
              </Card>
              <Card className="group hover:border-[#b3855e] transition-colors duration-300 bg-white shadow-sm sm:col-span-2 lg:col-span-1">
                <CardContent className="p-5 sm:p-6 lg:p-8">
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-3 mb-3 sm:mb-4">
                      <div className="p-3 rounded-full bg-[#f8f3ef] group-hover:bg-[#b3855e] transition-colors duration-300">
                        <Users className="h-6 w-6 sm:h-7 sm:w-7 text-[#b3855e] group-hover:text-white transition-colors duration-300" />
                      </div>
                      <h3 className="text-base sm:text-lg lg:text-xl text-[#b3855e] font-['MontserratAlt1']">
                        Personalização
                      </h3>
                    </div>
                    <p className="text-sm sm:text-base text-[#132034] text-center">
                      Atendimento personalizado em todas as etapas da sua viagem, com foco nas suas necessidades específicas.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Terceira Seção: Cadastur */}
        <section className="py-2 sm:py-6 lg:py-10">
          <div className="max-w-5xl mx-auto">
            <Card className="border-2 border-[#b3855e]">
              <CardContent className="p-6 sm:p-8 lg:p-12">
                <div className="flex items-start justify-between flex-col lg:flex-row gap-8 lg:gap-16">
                  <div className="flex-1 space-y-6 sm:space-y-8">
                    <div className="flex items-center gap-4 sm:gap-5">
                      <Shield className="h-8 w-8 sm:h-10 sm:w-10 lg:h-12 lg:w-12 text-[#b3855e] flex-shrink-0" />
                      <div>
                        <h2 className="text-xl sm:text-2xl lg:text-3xl text-[#132034] font-['MontserratAlt1'] font-light">
                          Registro Oficial
                        </h2>
                        <p className="text-lg sm:text-xl text-[#b3855e]">Cadastur</p>
                      </div>
                    </div>
                    <p className="text-base sm:text-lg lg:text-xl text-[#132034]">
                      A A Bordo Viagens é oficialmente registrada no Ministério do
                      Turismo através do Cadastur.
                    </p>
                    <div className="flex items-center gap-3">
                      <span className="font-semibold text-base sm:text-lg text-[#132034]">CNPJ:</span>
                      <span className="text-base sm:text-lg text-[#132034]">57.540.567/0001-78</span>
                    </div>
                    <p className="text-sm sm:text-base text-[#666] italic">
                      Este registro garante nosso compromisso em manter os mais
                      altos padrões na indústria do turismo e conformidade com
                      todas as exigências regulatórias.
                    </p>
                  </div>
                  <div className="flex-1 lg:flex-[0.8] flex items-center justify-center">
                    <img
                      src="/cadastur.jpg"
                      alt="Certificado Cadastur com QR Code"
                      className="w-full max-w-[450px] h-auto rounded-lg shadow-xl"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
      <WhatsAppButton />
    </div>
  );
}
